import { render, staticRenderFns } from "./ExampleEventSettings.vue?vue&type=template&id=3026fbc5&scoped=true"
import script from "./ExampleEventSettings.vue?vue&type=script&lang=js"
export * from "./ExampleEventSettings.vue?vue&type=script&lang=js"
import style0 from "./ExampleEventSettings.vue?vue&type=style&index=0&id=3026fbc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3026fbc5",
  null
  
)

export default component.exports